/**
 * Parse API error responses into user-friendly messages.
 *
 * Extracts error messages from various error formats and provides
 * custom messages for common error scenarios. Returns a new Error
 * instance with the parsed message, preserving the original error's
 * response, code, and a reference to the original error.
 *
 * @param {Error} error - Error object from API request
 * @returns {Error} Error instance with user-friendly message and preserved metadata
 *
 * @example
 * const error = parseErrors(axiosError)
 * console.log(error.message) // "We couldn't find an account with that email and password."
 * console.log(error.response) // Original axios response object
 * console.log(error.code) // Original error code
 * console.log(error.originalError) // Original error object
 */
export default function parseErrors(error) {
    const result =
        error.response?.data?.message || error.message || error.toString()

    const message = (() => {
        switch (result) {
            case 'Network Error':
                return "Something went wrong processing your request. We've been notified and we're looking into it."
            case 'No query results for model [App\\Models\\User].':
                return "We couldn't find an account with that email and password."
            default:
                return result
        }
    })()

    const parsedError = new Error(message)

    if (error?.response) {
        parsedError.response = error.response
    }

    if (error?.code) {
        parsedError.code = error.code
    }

    parsedError.originalError = error

    return parsedError
}
